/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IRemessaEmAndamentoRepository } from "@/interface/remessa-em-andamento";

const remessaEmAndamentoRepository: IRemessaEmAndamentoRepository = {
  /**
   * Função para buscar remessas em andamento do cliente
   * @param accessToken
   * @param cliente_id
   * @returns Promise<any | null>
   */
  async getAllRemessaEmAndamento<T>(
    accessToken: string,
    cliente_id: number,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const remessasEmAndamento = await Instance.get(
      `remessas/cliente/${cliente_id}/remessas-em-andamento?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return remessasEmAndamento?.data;
  },
};

/**
 * EXPORTS
 */
export { remessaEmAndamentoRepository };
